import type { UseMutationResult } from '@tanstack/react-query';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import type { AxiosError } from 'axios';
import { useTranslation } from 'react-i18next';
import { showErrorToast, showSuccessToast } from '../../../utils/toastUtils';
import { useClient } from '../../client-api';
import { removeDocumentFromClientPackage } from '../../generated/client';
import { queryKeys } from '../../query-keys';
import { useClientPackages } from '../queries';

export const useRemoveDocument = (clientId?: number, packageId?: number): UseMutationResult<void, AxiosError, number> => {
    const { t } = useTranslation();
    const queryClient = useQueryClient();
    const { data: client } = useClient();
    const { draftPackage } = useClientPackages();

    return useMutation({
        mutationFn: async (documentId) => {
            await removeDocumentFromClientPackage({ path: { id: packageId ?? draftPackage!.id, documentId } });
        },
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: queryKeys.clientPackagesForClient(clientId ?? client?.id) });
            showSuccessToast(t('clientPackageRemovedDocSuccess'));
        },
        onError: (error) => showErrorToast({ error, userMessage: t('failureActionGeneric') }),
    });
};
